const CACHE_BUSTER_KEY = "soluwhats-sw-version";
const CACHE_BUSTER_VALUE = "2026-06-08-login-fix-2";

async function resetCachedApp() {
  if (!("serviceWorker" in navigator)) return;

  try {
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(registrations.map((registration) => registration.unregister()));
  } catch (error) {
    console.error("Erro ao limpar service workers antigos:", error);
  }

  if ("caches" in window) {
    try {
      const cacheKeys = await caches.keys();
      await Promise.all(cacheKeys.map((key) => caches.delete(key)));
    } catch (error) {
      console.error("Erro ao limpar caches antigos:", error);
    }
  }
}

export function register() {
  console.log("Registrando service worker", navigator)
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
      const previousVersion = localStorage.getItem(CACHE_BUSTER_KEY);
      const shouldResetCache = previousVersion !== CACHE_BUSTER_VALUE;

      const registerServiceWorker = async () => {
        if (shouldResetCache) {
          await resetCachedApp();
          localStorage.setItem(CACHE_BUSTER_KEY, CACHE_BUSTER_VALUE);
        }

        return navigator.serviceWorker.register(swUrl);
      };

      registerServiceWorker()
        .then((registration) => {
          console.log('Service worker registrado com sucesso!', registration);
        })
        .catch((error) => {
          console.error('Erro durante o registro do service worker:', error);
        });
    });
  }
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error('Erro durante o desregistro do service worker:', error);
      });
  }
}
